import type { Dispatch, FC, SetStateAction } from 'react';
import React from 'react';
import useIntl from '../../../../hooks/useIntl';
import type { CartAdditionOption } from '../../../../../types/cart';
import type { OptionGroupDto } from '../../../../../generated-api/models/OptionGroupDto';
import { OptionGroupDtoProductTypeEnum } from '../../../../../generated-api/models/OptionGroupDto';
import OptionsSelection from './OptionsSelection';

interface Props {
  optionGroup: OptionGroupDto;
  setOptions: Dispatch<SetStateAction<CartAdditionOption[]>>;
  defaultOptions: CartAdditionOption[];
  isRequiredHandled: boolean;
}

const OptionGroupSection: FC<Props> = ({ optionGroup, setOptions, defaultOptions, isRequiredHandled }) => {
  const intl = useIntl();

  const name = () => {
    if (optionGroup.productType === OptionGroupDtoProductTypeEnum.ADDON) {
      return intl.formatMessage({ id: 'items.addon' });
    }
    if (optionGroup.productType === OptionGroupDtoProductTypeEnum.REMOVABLE) {
      return intl.formatMessage({ id: 'items.removable' });
    }
    if (optionGroup.productType === OptionGroupDtoProductTypeEnum.VARIANT) {
      return intl.formatMessage({ id: 'items.variant' });
    }

    return optionGroup.displayName;
  };

  return (
    <section id={optionGroup.optionGroupId}>
      <div className="flex">
        <p className={isRequiredHandled || !optionGroup.required ? 'text-bold' : 'text-bold text-orange-darkest'}>
          {name()}
        </p>
        {optionGroup.required && <p className="text-orange-darkest">*</p>}
      </div>
      <OptionsSelection optionGroup={optionGroup} setOptions={setOptions} defaultOptions={defaultOptions} />
    </section>
  );
};

export default OptionGroupSection;
